<!--
 * @Description: 获取图形验证码弹框，为公共组件
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-24 16:58:57
 * @LastEditors: luoshoufeng@szkingdom.com
-->
<template>
    <div class="comp-mobile-code comp">
        <el-dialog
            title="短信验证码"
            :visible.sync="visible"
            width="580px"
            class="prop"
            v-on:close="dialogClose"
        >
            <el-form ref="form" :model="form" :rules="ruleVerify" v-on:submit.native.prevent>
                <el-form-item label="">
                    <p class="prop-text">
                        <span class="mobile-text">手机号码：</span>
                        <span class="mobile-tip">
                            已向{{
                                mobileNo.indexOf("*") > -1
                                    ? mobileNo
                                    : $util.maskPhoneNumber(mobileNo)
                            }}手机发送短信，请注意查收!
                        </span>
                    </p>
                </el-form-item>
                <el-form-item label="" required>
                    <el-col :span="24">
                        <el-form-item label="" prop="verify">
                            <el-input
                                v-model.trim="form.verify"
                                class="img-code-val"
                                placeholder="输入短信验证码"
                                :maxlength="6"
                            />
                        </el-form-item>
                    </el-col>
                </el-form-item>
            </el-form>
            <el-form slot="footer" class="dialog-footer">
                <el-button class="cancel-btn" v-on:click="dialogClose">取 消</el-button>
                <el-button class="confirm-btn" type="primary" v-on:click="submitForm('form')">
                    确 定
                </el-button>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: "ImgCode",
    props: {
        mobileVisible: {
            type: Boolean,
            required: true
        },
        mobileNo: {
            type: String,
            default: () => {
                return "";
            }
        }
    },
    data() {
        return {
            form: {
                verify: ""
            },
            visible: false, // 是否显示dialog
            ruleVerify: {
                // 验证码校验
                verify: [
                    {
                        validator: this.$util.validateVerifyCode,
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    watch: {
        mobileVisible(val) {
            this.visible = val;
            if (!val) {
                this.$refs["form"].resetFields();
            }
        }
    },
    /* 初始化加载数据 */
    mounted() {},
    methods: {
        /* 提交表单数据 */
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$emit("verify-in", this.form.verify);
                } else {
                    this.$errorScroll();
                }
            });
        },
        dialogClose() {
            this.$emit("verify-in");
        }
    }
};
</script>
<style lang="scss">
.comp-mobile-code {
    .el-dialog__body {
        padding: 41px 72px 20px 72px !important;
    }
    .img-code-val {
        height: 50px;
        width: 400px !important;
        margin-top: 18px;
    }
    .mobile-text {
        font-size: 16px;
        font-weight: normal;
        color: #666666;
    }
    .mobile-tip {
        font-size: 16px;
        font-weight: normal;
        color: #333333;
    }
    .dialog-footer {
        padding-bottom: 20px;
        .cancel-btn {
            width: 180px;
            height: 42px;
            line-height: 42px;
            border-radius: 2px;
            background: #e4e4e4;
            font-size: 16px;
            font-weight: 500;
            text-align: center;
            color: #666666;
            cursor: pointer;
            border: none;
        }
        .confirm-btn {
            width: 180px;
            height: 42px;
            line-height: 42px;
            border-radius: 2px;
            background: var(--color-primary);
            font-size: 16px;
            font-weight: 500;
            text-align: center;
            color: #ffffff;
            cursor: pointer;
            border: none;
        }
    }
}
</style>
